import { askUserQuestion } from './ask-user-question';
import type { Capability } from './base';
import { shell } from './shell';

export {
  type AskUserQuestion,
  AskUserQuestionCapability,
  askUserQuestion,
} from './ask-user-question';
export { Capability } from './base';
export {
  type RestrictedShell,
  restrictedShell,
} from './restricted-shell';
export { type TaskList, TaskListCapability, taskList } from './task-list';

function defaultCapabilities(): Capability[] {
  return [shell(), askUserQuestion()];
}

export const Capabilities = {
  default: defaultCapabilities,
} as const;
